import React, { useEffect, useState } from "react";
import { ApiService } from "../../core/api-service";

const ConfigurablePage = () => {
    const [htmlContent, setHtmlContent] = useState<string | undefined>(undefined);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const apiService = new ApiService();
        apiService.get("protected/embeddedContent").then((html: string | undefined) => {
            if (html) {
                setHtmlContent(html);
            } else {
                setNotFound(true);
            }
        });
    }, []);

    if (notFound) {
        return <div style={{ padding: 24 }}>Content not available.</div>;
    }

    if (htmlContent === undefined) {
        return <div style={{ padding: 24 }}>Loading...</div>;
    }

    return (
        <iframe
            title="Configurable content"
            srcDoc={htmlContent}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                zIndex: 9999,
            }}
        />
    );
};

export default ConfigurablePage;
